import React, { useEffect, useState } from 'react';

import { ArrowDown } from '../../icons';
import {
  StyledArrow,
  StyledLabel,
  StyledSelect,
  StyledWrapper,
} from './CountryCodeDropDown.styles';
import { ICountryCodeDropDownProps } from './CountryCodeDropDown.types';
import { countryCodes } from './data';

const CountryCodeDropDown = ({
  id,
  selectedCountry,
  onChange,
}: ICountryCodeDropDownProps): JSX.Element => {
  const countryCodeDropDownId = `CountryCodeDropDown_${id}`;
  const filteredList = countryCodes;
  const value = selectedCountry
    ? filteredList.find(item => item.code === selectedCountry)
    : filteredList[0];
  const [selectValue, setSelectValue] = useState({ ...value });
  const handleOnChange = (event: React.ChangeEvent<HTMLSelectElement>) => {
    const targetObj = filteredList.find(
      item => item.code === event.target.value,
    );
    targetObj && setSelectValue(targetObj);
    onChange && onChange(targetObj?.phoneCode || '', true);
  };
  useEffect(() => {
    onChange && onChange(selectValue.phoneCode || '');
  }, [onChange, selectValue.phoneCode]);

  return (
    <StyledWrapper>
      <StyledSelect
        id={countryCodeDropDownId}
        defaultValue={selectValue.code}
        onChange={handleOnChange}
      >
        {filteredList.map((item, index) => (
          <option key={index} value={item.code}>
            {item.flag} {item.phoneCode} {item.name}
          </option>
        ))}
      </StyledSelect>
      <StyledLabel htmlFor={countryCodeDropDownId}>
        {selectValue.flag}
      </StyledLabel>
      <StyledArrow>
        <ArrowDown />
      </StyledArrow>
    </StyledWrapper>
  );
};

export default CountryCodeDropDown;
